export const getNumbersOfString = (string) => string.replace(/\D/g, '');
